import React from 'react';
import { observer } from "mobx-react";
import { useServices } from "../../../../../react-hooks/use-services.hook";
import { LiveCasinoGridItemBetIntervalBox } from "../boxes/bet-interval/live-casino-grid-item-bet-interval.box";
import { LiveCasinoGridItemBetIntervalMinWrapperBox } from "../boxes/bet-interval/live-casino-grid-item-bet-interval-min-wrapper.box";
import { Check } from "@sparkware/app-utils";
import {LiveCasinoMinMaxBetComponentProps} from "./live-casino-min-max-bet.component.props";

export const LiveCasinoMinMaxBet: React.FC<LiveCasinoMinMaxBetComponentProps> = observer((props) => {
    const services = useServices();

    const tableInfo = props.liveTable;
    let minBet: number;
    let maxBet: number;

    if (Check.isEmpty(tableInfo) || (tableInfo.MinBet === undefined || tableInfo.MaxBet === undefined)) {
        minBet = props.gameInfo.minBet;
        maxBet = props.gameInfo.maxBet;
    } else {
        minBet = tableInfo.MinBet;
        maxBet = tableInfo.MaxBet;
    }

    if (!minBet || !maxBet) {
        services.logger.info(`format$$$ invalid input for gameType => ${props.gameInfo.gameType} ${minBet}-${maxBet}`);
        return;
    }

    const renderMinBet = (minBet: number) => {
        return (
            <>
                {props.isHideMaxBet && <LiveCasinoGridItemBetIntervalMinWrapperBox>
                    {services.translation.translate('MIN_BET')}
                </LiveCasinoGridItemBetIntervalMinWrapperBox>}
                {services.currency.formatMoney(minBet, true)}
            </>
        );
    };


    return (
        <LiveCasinoGridItemBetIntervalBox className='cy-live-casino-grid-item-bet-interval'>
            <span>
                {
                    (services.device.isMobile || props.isHideMaxBet) ?
                        renderMinBet(minBet) :
                        services.currency.formatMinMaxBet(minBet, maxBet)
                }
            </span>
        </LiveCasinoGridItemBetIntervalBox>
    );
});